// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const alakazam: PokeData = {
  "id": 65,
  "name": "alakazam",
  "height": 15,
  "weight": 480,
  "base_experience": 225,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "disable",
    "psybeam",
    "confusion",
    "psychic",
    "hypnosis",
    "teleport",
    "night-shade",
    "recover",
    "barrier",
    "reflect",
    "kinesis",
    "flash",
    "substitute",
    "encore",
    "future-sight",
    "trick",
    "role-play",
    "calm-mind",
    "miracle-eye",
    "psycho-cut",
    "zen-headbutt",
    "psyshock",
    "telekinesis",
    "ally-switch"
  ],
  "moves": [
    "psychic",
    "night-shade",
    "reflect",
    "kinesis",
    "future-sight",
    "calm-mind",
    "zen-headbutt",
    "psychic-terrain",
    "psy-pulse",
    "healing-wish",
    "psychic-fangs",
    "psy-ball",
    "psywave"
  ],
  "evolution_chain": {
    "id": 27,
    "item": null,
    "species": [
      {
        "name": "abra",
        "order": 69,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kadabra",
        "order": 70,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 63,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "alakazam",
        "order": 71,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 64,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 79,
    "speed": 151,
    "ability_power": 170
  },
  "stat_changes": [],
  "catch_rate": 50,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
